(function () {
  "use strict";

  var roots = document.querySelectorAll("[data-faq-accordion]");

  if (!roots.length) {
    return;
  }

  var prefersReduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  roots.forEach(function (root) {
    var faq = root.querySelector("[data-faq]") || root;
    faq.classList.add("faq-page--enhanced");

    var categoryToggles = faq.querySelectorAll(".faq-page__category-toggle");
    categoryToggles.forEach(function (toggle) {
      var panelId = toggle.getAttribute("aria-controls");
      var panel = panelId ? faq.querySelector('[id="' + panelId.replace(/"/g, '\\"') + '"]') : null;

      if (!panel) {
        return;
      }

      toggle.addEventListener("click", function () {
        var isExpanded = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!isExpanded));
        panel.hidden = isExpanded;
      });
    });

    var items = faq.querySelectorAll("[data-faq-item]");

    items.forEach(function (details) {
      var summary = details.querySelector("summary");
      var wrap = details.querySelector("[data-faq-answer-wrap]");

      if (!summary || !wrap) {
        return;
      }

      if (!details.open) {
        wrap.style.height = "0px";
      } else {
        wrap.style.height = "auto";
      }

      summary.addEventListener("click", function (event) {
        event.preventDefault();

        if (prefersReduced) {
          details.open = !details.open;
          wrap.style.height = details.open ? "auto" : "0px";
          return;
        }

        if (details.open) {
          var startHeight = wrap.scrollHeight;
          wrap.style.height = startHeight + "px";
          void wrap.offsetHeight;

          requestAnimationFrame(function () {
            wrap.style.height = "0px";
          });

          wrap.addEventListener("transitionend", function handler(e) {
            if (e.propertyName !== "height") {
              return;
            }

            details.open = false;
            wrap.removeEventListener("transitionend", handler);
          });
        } else {
          details.open = true;
          var targetHeight = wrap.scrollHeight;
          wrap.style.height = "0px";
          void wrap.offsetHeight;

          requestAnimationFrame(function () {
            wrap.style.height = targetHeight + "px";
          });

          wrap.addEventListener("transitionend", function handler(e) {
            if (e.propertyName !== "height") {
              return;
            }

            wrap.style.height = "auto";
            wrap.removeEventListener("transitionend", handler);
          });
        }
      });
    });
  });
})();
